export default {
    data () {
        return {
            inner_val: this.record.val
        }
    },
    watch: {
        'record.val'  (val) {
            this.inner_val = val
        }
    },
    methods: {
        changeInnerVal (e) {
            const { value } = e.target
            this.inner_val = value
            if (Number.isNaN(Number(value))) {
                this.$nextTick(() => {
                    this.inner_val = ''
                })
            }
        },
        changeVal () {
            this.$emit('change', {
                ...this.record,
                val: this.inner_val
            })
        }
    }
}